import { cva } from "styled-system/css";

export const sortableRecipe = cva({
  base: {
    gridTemplateColumns: {
      base: "minmax(0, 1fr) minmax(0, 1fr)",
      lg: "minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr)",
    },
    gap: "300",
    width: "100%",
    overflow: "hidden",
  },
  variants: {
    size: {
      screen: {},
      modal: {
        gridTemplateColumns: "minmax(0, 1fr) minmax(0, 1fr)",
        gap: "200",
      },
      compact: {
        gridTemplateColumns: "minmax(0, 1fr)",
        gap: "150",
        overflow: "visible",
      },
    },
  },
  defaultVariants: {
    size: "screen",
  },
});
